import { FC, ReactNode } from 'react';

import InfoMessage from '@components/ui/InfoMessage';

type EmptyMessageProps = {
  title?: string;
  subtitle?: string;
  error?: boolean;
  button?: ReactNode;
};

export const EmptyMessage: FC<EmptyMessageProps> = ({
  title,
  subtitle,
  error,
  button,
}) => (
  <InfoMessage
    title={title}
    subtitle={subtitle}
    sx={{ flex: 1, height: '100%' }}
    error={error}
    button={button}
    data-testid='empty-grid-message'
  />
);

export const DefaultEmptyMessage = (
  <EmptyMessage
    title='В даному розділі немає записів'
    subtitle='Перейдіть до створення або перегляньте параметри пошуку'
  />
);

export const DefaultEmptyMessageComponent = () => (
  <EmptyMessage
    title='В даному розділі немає записів'
    subtitle='Перейдіть до створення або перегляньте параметри пошуку'
  />
);
